import { ApprovalMethodTypeDTO as ApprovalMethodType } from 'anchor-ts-infra/src/dto/approval-method/dto';
import { FailureCodeEnum as InvoicePaymentFailureCode } from 'anchor-ts-infra/src/dto/invoice/dto';
export { ApprovalMethodType, InvoicePaymentFailureCode };
export let InvoiceDisplayStatus = /*#__PURE__*/function (InvoiceDisplayStatus) {
  InvoiceDisplayStatus["Issued"] = "issued";
  InvoiceDisplayStatus["PaymentInitiated"] = "paymentInitiated";
  InvoiceDisplayStatus["Paid"] = "paid";
  InvoiceDisplayStatus["Overdue"] = "overdue";
  InvoiceDisplayStatus["Voided"] = "voided";
  InvoiceDisplayStatus["Refunded"] = "refunded";
  InvoiceDisplayStatus["PartiallyRefunded"] = "partiallyRefunded";
  InvoiceDisplayStatus["RefundFailed"] = "refundFailed";
  InvoiceDisplayStatus["PaymentDisputed"] = "disputed";
  return InvoiceDisplayStatus;
}({});
export let InvoicePaymentMethodStatus = /*#__PURE__*/function (InvoicePaymentMethodStatus) {
  InvoicePaymentMethodStatus["PaymentMethodSet"] = "paymentMethodSet";
  InvoicePaymentMethodStatus["PaymentMethodNotSet"] = "paymentMethodNotSet";
  InvoicePaymentMethodStatus["PaymentMethodUnverified"] = "paymentMethodUnverified";
  return InvoicePaymentMethodStatus;
}({});
export let InvoiceIntegrationStatusEnum = /*#__PURE__*/function (InvoiceIntegrationStatusEnum) {
  InvoiceIntegrationStatusEnum["PendingSync"] = "pendingSync";
  InvoiceIntegrationStatusEnum["InvoiceSyncFailed"] = "invoiceSyncFailed";
  InvoiceIntegrationStatusEnum["PaymentSyncFailed"] = "paymentSyncFailed";
  InvoiceIntegrationStatusEnum["RefundSyncFailed"] = "refundSyncFailed";
  InvoiceIntegrationStatusEnum["InvoiceRecorded"] = "invoiceRecorded";
  InvoiceIntegrationStatusEnum["VoidedRecorded"] = "voidedRecorded";
  InvoiceIntegrationStatusEnum["RefundRecorded"] = "refundRecorded";
  InvoiceIntegrationStatusEnum["PaymentRecorded"] = "paymentRecorded";
  return InvoiceIntegrationStatusEnum;
}({});
export let InvoicePaymentDisplayStatusType = /*#__PURE__*/function (InvoicePaymentDisplayStatusType) {
  InvoicePaymentDisplayStatusType["PaymentMethodNotSet"] = "paymentMethodNotSet";
  InvoicePaymentDisplayStatusType["PaymentMethodUnverified"] = "paymentMethodUnverified";
  InvoicePaymentDisplayStatusType["PaymentFailed"] = "paymentFailed";
  InvoicePaymentDisplayStatusType["Paid"] = "paid";
  InvoicePaymentDisplayStatusType["PaidExternally"] = "paidExternally";
  InvoicePaymentDisplayStatusType["RequiresPaymentApproval"] = "requiresPaymentApproval";
  InvoicePaymentDisplayStatusType["RequiresPaymentValidation"] = "requiresPaymentValidation";
  InvoicePaymentDisplayStatusType["Processing"] = "processing";
  InvoicePaymentDisplayStatusType["Collected"] = "collected";
  InvoicePaymentDisplayStatusType["Refunded"] = "refunded";
  InvoicePaymentDisplayStatusType["RefundFailed"] = "refundFailed";
  InvoicePaymentDisplayStatusType["RefundRequested"] = "refundRequested";
  InvoicePaymentDisplayStatusType["Pending"] = "pending";
  InvoicePaymentDisplayStatusType["StoppedPayment"] = "stoppedPayment";
  InvoicePaymentDisplayStatusType["Disputed"] = "disputed";
  InvoicePaymentDisplayStatusType["None"] = "none";
  return InvoicePaymentDisplayStatusType;
}({});
export let InvoiceAccountingSyncStatusFilter = /*#__PURE__*/function (InvoiceAccountingSyncStatusFilter) {
  InvoiceAccountingSyncStatusFilter["Synced"] = "sync";
  InvoiceAccountingSyncStatusFilter["Unsynced"] = "unsync";
  return InvoiceAccountingSyncStatusFilter;
}({});
export let InvoiceApiStatusType = /*#__PURE__*/function (InvoiceApiStatusType) {
  InvoiceApiStatusType["RequiresPaymentApproval"] = "requiresPaymentApproval";
  InvoiceApiStatusType["PaymentActionRequired"] = "paymentActionRequired";
  InvoiceApiStatusType["PaymentFailed"] = "paymentFailed";
  InvoiceApiStatusType["Pending"] = "pending";
  InvoiceApiStatusType["ProcessingCharge"] = "processingCharge";
  InvoiceApiStatusType["PaymentConfirmed"] = "paymentConfirmed";
  InvoiceApiStatusType["Paid"] = "paid";
  InvoiceApiStatusType["PaidExternally"] = "paidExternally";
  InvoiceApiStatusType["Voided"] = "voided";
  InvoiceApiStatusType["Refunded"] = "refunded";
  InvoiceApiStatusType["RefundFailed"] = "refundFailed";
  InvoiceApiStatusType["PaymentStopped"] = "paymentStopped";
  InvoiceApiStatusType["PaymentDisputed"] = "paymentDisputed";
  InvoiceApiStatusType["PartiallyRefunded"] = "partiallyRefunded";
  return InvoiceApiStatusType;
}({});
export let InvoiceSortingColumn = /*#__PURE__*/function (InvoiceSortingColumn) {
  InvoiceSortingColumn["Number"] = "number";
  InvoiceSortingColumn["CompanyName"] = "companyName";
  InvoiceSortingColumn["Status"] = "status";
  InvoiceSortingColumn["PaymentStatus"] = "paymentStatus";
  InvoiceSortingColumn["IssuedOn"] = "issuedOn";
  InvoiceSortingColumn["DueDate"] = "dueDate";
  InvoiceSortingColumn["TotalAmount"] = "totalAmount";
  return InvoiceSortingColumn;
}({});